import React from 'react';
import { SFPopover, SFPopoverProps } from 'sfui';
import {
  ReportSortGroupByButtonMenu,
  ReportSortGroupByButtonMenuProps
} from '../ReportSortGroupByButtonMenu/ReportSortGroupByButtonMenu';

export interface ReportSortGroupByButtonPopoverProps
  extends ReportSortGroupByButtonMenuProps,
    SFPopoverProps {
  onClose: () => void;
}

export const ReportSortGroupByButtonPopover = (
  props: ReportSortGroupByButtonPopoverProps
): React.ReactElement<ReportSortGroupByButtonPopoverProps> => {
  return (
    <SFPopover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <ReportSortGroupByButtonMenu
        groupedBy={props.groupedBy}
        sortBy={props.sortBy}
        onGroupedByChange={(g) => {
          props.onClose();
          props.onGroupedByChange(g);
        }}
        onSortByChange={(g) => {
          props.onClose();
          props.onSortByChange(g);
        }}
      />
    </SFPopover>
  );
};
